"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADJUSTMENT_STATIC_NAME = exports.COMBO_DISCOUNT_ID = exports.CUSTOM_ADJUSTMENT_ID = void 0;
exports.CUSTOM_ADJUSTMENT_ID = 'CUSTOM_ADJUSTMENT_ID';
exports.COMBO_DISCOUNT_ID = 'COMBO_DISCOUNT_ID';
/* This is name which we use for migration,
  We're not appending adjustment value after adjustment name in function map for this name
  We're showing generic name for adjustments like Discount and Surcharge for this name
*/
exports.ADJUSTMENT_STATIC_NAME = [
    '100% OFF',
    '10% OFF',
    '5% OFF',
    '1.9% SURCHARGE',
    '2% SURCHARGE',
    '2.5% SURCHARGE',
    '$2 OFF',
    '$10 OFF',
    '$5 OFF',
    '$2 SURCHARGE',
    '$1 SURCHARGE',
    '$1.5 SURCHARGE',
];
//# sourceMappingURL=adjustments.js.map